import * as React from "react";
import type { SVGProps } from "react";
const SvgSmartwings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <clipPath id="smartwings_svg__a">
      <path d="M0 0h50v50H0z" />
    </clipPath>
    <g clipPath="url(#smartwings_svg__a)">
      <path
        fill="#ff8c00"
        d="M13.528 9.942c2.378-.308 8.284-1.156 10.432-1.619 2.07-.463 13.884-2.236 19.867-2.314 6.06-.077 5.753.309 5.83 1.466.153 1.156.69 1.542 0 2.622-.768 1.08-1.995 1.542-3.836 2.236-3.375 1.311-18.18 5.321-20.174 6.324 3.069-.154 7.518-.926 11.966-1.157 2.992-.077 3.375.54 3.606 1.928.306 1.31.383 2.005-1.611 2.776-1.995.771-4.296 1.62-8.975 3.008-6.52 1.928-10.432 2.776-15.264 4.935 2.685.309 7.057-.154 10.585 0 5.293.155 5.523.771 5.753 2.39.077 1.543.307 2.006-1.918 3.086-2.224.925-6.136 2.005-8.284 2.467a883 883 0 0 0-12.12 2.7c-1.457.385-2.684 2.004-4.908 2.776-2.455.848-3.529.462-4.373-1.234-.537-1.311 1.074-2.468 3.069-3.085 1.994-.54 8.13-1.928 10.738-2.622s7.748-2.082 9.435-2.776c-2.301 0-7.9.077-12.273.154-2.608.077-3.528-.077-3.912-2.005s.384-2.622 2.685-3.239c2.301-.771 5.753-2.313 7.9-3.085 2.148-.77 8.438-3.007 10.126-3.393-4.219-.077-13.654 2.005-16.032 2.468-1.917.386-2.07-.308-2.838-1.542-.767-1.311.154-2.237 1.304-2.468 1.458-.386 4.219-1.697 8.131-3.239 3.145-1.234 7.517-2.622 10.816-3.624 3.068-1.08 8.284-2.854 10.048-3.548-1.304 0-7.517.848-11.66 1.465-3.988.54-10.968 2.005-12.042 2.39s-2.301.31-2.992-1.31-.076-2.468.92-2.622"
      />
    </g>
  </svg>
);
export default SvgSmartwings;
